export default [
    {
        path: '/samo/hotel/add',
        name: 'samo_new_hotel',
        component: () => import('@/views/samo/templates/NewHotel.vue'),
        meta: { access: 'auth', title: 'routes.samo.new_hotel' },
    },
    {
        path: '/samo/hotel',
        name: 'samo_hotel',
        component: () => import('@/views/samo/templates/HotelList.vue'),
        meta: { access: 'auth', title: 'routes.samo.hotel_list' },
    },
    {
        path: '/samo/hotel/:id/templates',
        name: 'samo_hotel_templates',
        component: () => import('@/views/samo/templates/NewHotel.vue'),
        meta: { access: 'auth', title: 'routes.samo.hotel_templates' },
    },
    {
        path: '/samo/setting/db',
        name: 'samo_db_setting',
        component: () => import('@/views/samo/setting/db.vue'),
        meta: { access: 'auth', title: 'routes.samo.db_setting', permissions: ['samo.db.setting'] },
    },
    {
        path: '/samo/setting',
        name: 'samo_setting',
        component: () => import('@/views/samo/setting/template.vue'),
        meta: { access: 'auth', title: 'routes.samo.setting', permissions: ['samo.system.setting'] },
    },
    {
        path: '/samo/setting/age-baskets',
        name: 'samo_age_setting',
        component: () => import('@/views/samo/setting/age_baskets.vue'),
        meta: { access: 'auth', title: 'routes.samo.age_setting', permissions: ['samo.system.setting'] },
    },
    {
        path: '/task-manager/',
        name: 'TemplateRequests',
        component: () => import('@/views/samo/TemplateRequests.vue'),
        meta: { access: 'auth', title: 'routes.samo.requests' }
    },
    {
        path: '/requests/templates/:id',
        name: 'TemplateRequestView',
        component: () => import('@/views/samo/TaskPage.vue'),
        meta: { access: 'auth', title: 'routes.samo.request_view' }
    },
];